var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var TagOptionList = require('./tagOptionList.jsx');

var TagInput = createReactClass({
    mixins: [PureRenderMixin],

    getInitialState: function(){
        return {
            inputTagName: '',
            isShowTagOptionList: false
        };
    },

    handleTagOptionChange: function(tag){
        this.setState({
            inputTagName: ''
        });

        this.hideTagOptionList();

        this.props.onTagAdd(tag);
    },

    showTagOptionList: function(){
        this.setState({
            isShowTagOptionList: true
        });
    },

    hideTagOptionList: function(){
        // delay for onClick on select-list item take effect before hide
        setTimeout(function(){
            this.setState({
                isShowTagOptionList: false
            });
        }.bind(this), 150);
    },

    handleInputTagNameChange: function(event){
        this.setState({
            inputTagName: event.target.value
        });
    },

    render: function () {
        return (
            <div className="tag-input">
                <input type="text" value={this.state.inputTagName} onChange={this.handleInputTagNameChange} onFocus={this.showTagOptionList} onBlur={this.hideTagOptionList} />
                <span className="trigger ion-ios-arrow-down"></span>
                <TagOptionList
                    tagsForSelect={this.props.tagsForSelect}
                    filterText={this.state.inputTagName}
                    isShowTagOptionList={this.state.isShowTagOptionList}
                    onTagOptionChange={this.handleTagOptionChange} />
            </div>
        );
    }
});

module.exports = TagInput;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/layout/tagInput.jsx